import {GradientColor} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/color.types';

/**
 * Converts a backend RGBA glow colour into a ready-to-use CSS `rgba(...)`
 * string for the glow layers (ambient + card). Alpha defaults to fully opaque
 * per the schema (mirrors `PromotionBannerView`).
 */
export const gradientColorToCss = ({
  red,
  green,
  blue,
  alpha,
}: GradientColor): string => `rgba(${red}, ${green}, ${blue}, ${alpha ?? 1})`;

/**
 * --slide-card-width = width = window with - edge screen side padding - inner slider side padding
 * --slider-inner-padding = fixed padding by design (top & bottom)
 * --slider-outer-padding = fixed padding by design (top & bottom)
 */
export const spotlightSliderAmbientHeightCSS = `
  --slide-card-width: calc(100vw - calc(16px * 2) - calc(16px * 2) - calc(16px * 2));
  --slider-inner-padding: calc(24px + 43px);
  --slider-outer-padding: calc(16px + 24px);
  --guesstimate-text-content-height: 40px;
  --guesstimate-pagination-height: 36px;
  --slider-height: calc(var(--slide-card-width) + var(--slider-inner-padding) + var(--slider-outer-padding) + var(--guesstimate-text-content-height) + var(--guesstimate-pagination-height));
  
  height: var(--slider-height);
`;

export const spotlightSliderHeightCSS = `
  height: calc(100vw * calc(487 / 1440));
`;
